var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrayArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1511_6164)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.35618 21.0042L13.9676 9.53337L7.12704 11.3119L6.28391 8.34497L18.2711 5.26603L21.5994 17.1724L18.6423 17.9489L16.7359 11.1289L10.1245 22.5997L7.35618 21.0042Z",
    fill: "#676767"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1511_6164"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.1164,
    height: 19.5677,
    fill: "white",
    transform: "translate(16.4294 26.5) rotate(-150.042)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayArrow);
export default __webpack_public_path__ + "static/media/grayArrow.920743822235188aed9cb93cf8114f47.svg";
export { ForwardRef as ReactComponent };